
import React from "react";
import { motion } from "framer-motion";
import { Shirt } from "lucide-react";

interface AuthLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const AuthLayout = ({ title, description, children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-madts-gray/20 flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="flex justify-center mb-6">
            <div className="bg-madts-purple/10 p-3 rounded-full">
              <Shirt className="h-10 w-10 text-madts-purple" />
            </div>
          </div>
          
          <h1 className="text-3xl font-display font-bold text-center mb-2">
            {title}
          </h1>
          <p className="text-gray-500 text-center mb-8">
            {description}
          </p>
          
          {children}
        </div>
      </motion.div>
    </div>
  );
};
